import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

import { MenuMemoed, MenuRaw } from './raw';

export const Menu = componentWithFG('navx-3138-gas-menu-rendering-perf-fix', MenuMemoed, MenuRaw);
